import routes from '@/modules/wallet/wallet-routes';
import store from '@/modules/wallet/wallet-store';

export default {
  routes,
  store,
};
